import Vue from "vue";
import Router from "vue-router";
import routerMap from "./router.js";

import store from "@/stores";

Vue.use(Router);
const router = new Router({
  base: process.env.BASE_URL,
  routes: routerMap.routes
});
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0); //回到頂部

  next();

  if (!from.name) {
    return;
  }
});

function isMobile() {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return "Mobile";
  } else {
    return "Desktop";
  }
};
export default router;
